import { c as _c } from "react/compiler-runtime";
import { SideMenuGroup } from '@/app/components/SideMenuGroup';
import { SideMenuItem } from '@/app/components/SideMenuItem';
// import AccountTreeRounded from '@mui/icons-material/AccountTreeRounded'
import Announcement from '@mui/icons-material/Announcement';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DeveloperBoardRounded from '@mui/icons-material/DeveloperBoardRounded';
import DvrIcon from '@mui/icons-material/Dvr';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Engineering from '@mui/icons-material/EngineeringRounded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import FolderIcon from '@mui/icons-material/Folder';
import HomeIcon from '@mui/icons-material/Home';
import HubRounded from '@mui/icons-material/HubRounded';
import ListAlt from '@mui/icons-material/ListAlt';
import OilBarrel from '@mui/icons-material/OilBarrelRounded';
import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturingRounded';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SettingsApplications from '@mui/icons-material/SettingsApplicationsRounded';
import Source from '@mui/icons-material/SourceRounded';
import TableChartIcon from '@mui/icons-material/TableChart';
import Warehouse from '@mui/icons-material/WarehouseRounded';
import Work from '@mui/icons-material/WorkOutline';
import Badge from '@mui/material/Badge';
import * as colors from '@mui/material/colors';
import { ROUTES } from '@shared/routes';
import { useSearchParams } from 'next/navigation';
import { type FC } from 'react';
interface SideMenuPages {
  isMenuOpen: boolean;
  hasJmtAccess?: boolean;
  hasQmtAccess?: boolean;
  qmtLabel?: string;
}
const QmtMenuItem: FC<{
  isMenuOpen: boolean;
  label?: string;
}> = t0 => {
  const $ = _c(4);
  const {
    isMenuOpen,
    label: t1
  } = t0;
  const label = t1 === undefined ? "Opportunity List" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RequestQuoteIcon />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isMenuOpen || $[2] !== label) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.opt.base}>{label}</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const CommonPages: FC<SideMenuPages> = t0 => {
  const $ = _c(17);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess,
    qmtLabel
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.toString();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const jobsRoute = `${ROUTES.jobs.base}?${t1}`;
  const showJmtAccess = hasJmtAccess ?? true;
  const showQmtAccess = hasQmtAccess ?? false;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HomeIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.home}>Home</SideMenuItem>;
    $[3] = isMenuOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isMenuOpen || $[6] !== qmtLabel || $[7] !== showQmtAccess) {
    t4 = showQmtAccess && <QmtMenuItem isMenuOpen={isMenuOpen} label={qmtLabel} />;
    $[5] = isMenuOpen;
    $[6] = qmtLabel;
    $[7] = showQmtAccess;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isMenuOpen || $[10] !== jobsRoute || $[11] !== showJmtAccess) {
    t5 = showJmtAccess && <><SideMenuItem isMenuOpen={isMenuOpen} icon={<Work />} route={jobsRoute}>Job List</SideMenuItem><SideMenuItem isMenuOpen={isMenuOpen} icon={<ListAlt />} route={ROUTES.sheets.base}>PPT List</SideMenuItem></>;
    $[9] = isMenuOpen;
    $[10] = jobsRoute;
    $[11] = showJmtAccess;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const GuestPages: FC<SideMenuPages> = t0 => {
  const $ = _c(4);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen) {
    t1 = <CommonPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} />;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const UserPages: FC<SideMenuPages> = t0 => {
  const $ = _c(5);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess,
    qmtLabel
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen || $[3] !== qmtLabel) {
    t1 = <><CommonPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} qmtLabel={qmtLabel} /></>;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = qmtLabel;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export const SiteManagerPages: FC<SideMenuPages> = t0 => {
  const $ = _c(14);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} qmtLabel="QMT" />;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Source />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.operationFamilies.base}>Recipes</SideMenuItem>;
    $[5] = isMenuOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PrecisionManufacturing />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isMenuOpen) {
    t5 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t4} route={ROUTES.workstations.base}>Workstations</SideMenuItem>;
    $[8] = isMenuOpen;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t5) {
    t6 = <>{t1}{t3}{t5}</>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const AdminPages: FC<SideMenuPages & {
  newSuggestionsCount?: number;
}> = t0 => {
  const $ = _c(100);
  const {
    isMenuOpen,
    newSuggestionsCount
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} hasJmtAccess={true} hasQmtAccess={true} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AttachMoneyIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DvrIcon />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.opt.operations}>Operations</SideMenuItem>;
    $[4] = isMenuOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FolderIcon />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMenuOpen) {
    t6 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t5} route={ROUTES.opt.technologies}>Technologies</SideMenuItem>;
    $[7] = isMenuOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SavedSearchIcon />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMenuOpen) {
    t8 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t7} route={ROUTES.opt.lookupTables}>Lookup Tables</SideMenuItem>;
    $[10] = isMenuOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChecklistIcon />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isMenuOpen) {
    t10 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t9} route={ROUTES.opt.coreFormulas}>Core Formulas</SideMenuItem>;
    $[13] = isMenuOpen;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t11 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t2} title="Pricing Admin">{t4}{t6}{t8}{t10}</SideMenuGroup>;
    $[15] = isMenuOpen;
    $[16] = t10;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <RequestQuoteIcon />;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FactCheckIcon />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isMenuOpen) {
    t14 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t13} route={ROUTES.opt.assumptions}>Assumptions</SideMenuItem>;
    $[23] = isMenuOpen;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <TableChartIcon />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== isMenuOpen) {
    t16 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t15} route={ROUTES.opt.dataStore}>Data Store</SideMenuItem>;
    $[26] = isMenuOpen;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <PriceChangeIcon />;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== isMenuOpen) {
    t18 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t17} route={ROUTES.opt.standardPrices}>Standard Prices</SideMenuItem>;
    $[29] = isMenuOpen;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ReceiptIcon />;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== isMenuOpen) {
    t20 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t19} route={ROUTES.opt.quoteTypes}>Quote Types</SideMenuItem>;
    $[32] = isMenuOpen;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <QuestionAnswer />;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== isMenuOpen) {
    t22 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t21} route={ROUTES.opt.suggestions}>QMT Suggestions</SideMenuItem>;
    $[35] = isMenuOpen;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== isMenuOpen || $[38] !== t14 || $[39] !== t16 || $[40] !== t18 || $[41] !== t20 || $[42] !== t22) {
    t23 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t12} title="Quoting Admin">{t14}{t16}{t18}{t20}{t22}</SideMenuGroup>;
    $[37] = isMenuOpen;
    $[38] = t14;
    $[39] = t16;
    $[40] = t18;
    $[41] = t20;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <EngineeringIcon />;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <DeveloperBoardRounded />;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== isMenuOpen) {
    t26 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t25} route={ROUTES.operations.base}>Operations</SideMenuItem>;
    $[46] = isMenuOpen;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  let t27;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Source />;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== isMenuOpen) {
    t28 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t27} route={ROUTES.operationFamilies.base}>Recipes</SideMenuItem>;
    $[49] = isMenuOpen;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <HubRounded />;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== isMenuOpen) {
    t30 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t29} route={ROUTES.core.base}>Core Sections</SideMenuItem>;
    $[52] = isMenuOpen;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SettingsApplications />;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== isMenuOpen) {
    t32 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t31} route={ROUTES.template.edit}>Edit PPT Template</SideMenuItem>;
    $[55] = isMenuOpen;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== isMenuOpen || $[58] !== t26 || $[59] !== t28 || $[60] !== t30 || $[61] !== t32) {
    t33 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t24} title="Job Admin">{t26}{t28}{t30}{t32}</SideMenuGroup>;
    $[57] = isMenuOpen;
    $[58] = t26;
    $[59] = t28;
    $[60] = t30;
    $[61] = t32;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] !== newSuggestionsCount) {
    t34 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><AssuredWorkloadIcon sx={{
        color: colors.yellow[500]
      }} /></Badge> : <AssuredWorkloadIcon />;
    $[63] = newSuggestionsCount;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Warehouse />;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== isMenuOpen) {
    t36 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t35} route={ROUTES.sites.base}>Sites</SideMenuItem>;
    $[66] = isMenuOpen;
    $[67] = t36;
  } else {
    t36 = $[67];
  }
  let t37;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <OilBarrel />;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  let t38;
  if ($[69] !== isMenuOpen) {
    t38 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t37} route={ROUTES.materialTypes.base}>Materials</SideMenuItem>;
    $[69] = isMenuOpen;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Engineering />;
    $[71] = t39;
  } else {
    t39 = $[71];
  }
  let t40;
  if ($[72] !== isMenuOpen) {
    t40 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t39} route={ROUTES.engineers.base}>Engineers</SideMenuItem>;
    $[72] = isMenuOpen;
    $[73] = t40;
  } else {
    t40 = $[73];
  }
  let t41;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <PrecisionManufacturing />;
    $[74] = t41;
  } else {
    t41 = $[74];
  }
  let t42;
  if ($[75] !== isMenuOpen) {
    t42 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t41} route={ROUTES.workstations.base}>Workstations</SideMenuItem>;
    $[75] = isMenuOpen;
    $[76] = t42;
  } else {
    t42 = $[76];
  }
  let t43;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <ScheduleIcon />;
    $[77] = t43;
  } else {
    t43 = $[77];
  }
  let t44;
  if ($[78] !== isMenuOpen) {
    t44 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t43} route={ROUTES.jobDelayReasons.base}>Job Delay Reasons</SideMenuItem>;
    $[78] = isMenuOpen;
    $[79] = t44;
  } else {
    t44 = $[79];
  }
  let t45;
  if ($[80] !== newSuggestionsCount) {
    t45 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><Announcement sx={{
        color: colors.yellow[500]
      }} /></Badge> : <QuestionAnswer />;
    $[80] = newSuggestionsCount;
    $[81] = t45;
  } else {
    t45 = $[81];
  }
  let t46;
  if ($[82] !== isMenuOpen || $[83] !== t45) {
    t46 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t45} route={ROUTES.suggestions.base}>Suggestions</SideMenuItem>;
    $[82] = isMenuOpen;
    $[83] = t45;
    $[84] = t46;
  } else {
    t46 = $[84];
  }
  let t47;
  if ($[85] !== isMenuOpen || $[86] !== t34 || $[87] !== t36 || $[88] !== t38 || $[89] !== t40 || $[90] !== t42 || $[91] !== t44 || $[92] !== t46) {
    t47 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t34} title="General Admin">{t36}{t38}{t40}{t42}{t44}{t46}</SideMenuGroup>;
    $[85] = isMenuOpen;
    $[86] = t34;
    $[87] = t36;
    $[88] = t38;
    $[89] = t40;
    $[90] = t42;
    $[91] = t44;
    $[92] = t46;
    $[93] = t47;
  } else {
    t47 = $[93];
  }
  let t48;
  if ($[94] !== t1 || $[95] !== t11 || $[96] !== t23 || $[97] !== t33 || $[98] !== t47) {
    t48 = <>{t1}{t11}{t23}{t33}{t47}</>;
    $[94] = t1;
    $[95] = t11;
    $[96] = t23;
    $[97] = t33;
    $[98] = t47;
    $[99] = t48;
  } else {
    t48 = $[99];
  }
  return t48;
};